import cn from 'clsx'
import { Image } from '~/components/image'
import { Link } from '~/components/link'
import s from './pricing.module.css'

export function BottomPromo({ className }) {
  return (
    <div
      className={cn(
        s.subtext,
        'w-full h-fit flex flex-col dt:flex-row items-center dr-p-20 dr-pt-90 -dr-mt-91 dr-rounded-10 overflow-hidden dr-gap-20 dt:dr-gap-34 justify-between relative',
        className
      )}
    >
      <p className="relative p">
        Or get the Every bundle for full access to all of our apps (Cora,{' '}
        <a href="https://spiral.computer" className="underline">
          Spiral
        </a>{' '}
        and{' '}
        <a href="https://makeitsparkle.co" className="underline">
          Sparkle
        </a>
        ) and ideas at the frontier of AI for only $30 per month
      </p>

      {/* ONBOARDING BUTTON */}
      <Link
        href="https://every.to/subscribe"
        className="relative flex items-center dr-gap-5 text-nowrap dr-px-26 dr-py-12 transition-all duration-300 bg-[#00000075] hover:bg-[#ffffff15] dr-rounded-9999 border border-solid border-white backdrop-blur-[4px] max-dt:w-full max-dt:justify-center"
      >
        <span className="cta-md flex-shrink-0">Subscribe to</span>
        <picture className="relative dr-w-54">
          <Image src="/images/every.png" alt="logo" className="!dr-w-54" />
        </picture>
      </Link>
    </div>
  )
}
